import { SVGProps } from 'react';

const SvgScaleUnbalanced = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 640 512"
    width="1em"
    height="1em"
    {...props}
  >
    <path d="M542.9 16.7c4 12.6-2.9 26.1-15.5 30.2L399.6 87.7c-3.1 32.4-25.5 59.2-55.6 68.6V464h176c13.3 0 24 10.7 24 24s-10.7 24-24 24H320c-13.3 0-24-10.7-24-24V156.3c-14.2-4.5-26.8-12.8-36.4-23.8l-132.3 42.4c-12.6 4-26.1-2.9-30.2-15.5s2.9-26.1 15.5-30.2l127.8-40.9c-.3-2.7-.4-5.5-.4-8.3 0-44.2 35.8-80 80-80 29.8 0 55.8 16.3 69.6 40.5L512.7 1.1c12.6-4 26.1 2.9 30.2 15.5zM512 163.8 439.6 288h144.8L512 163.8zM386 305.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8L631.3 273c5.7 9.8 9.3 21.1 6.7 32.1C627.2 350 574.9 384 512 384s-115.2-34-126-78.9zM56.7 416h144.9l-72.4-124.2L56.7 416zm72.4 96C66.3 512 14 478 3.2 433.1c-2.6-11 1-22.3 6.7-32.1l95.2-163.2c5-8.6 14.2-13.8 24.1-13.8s19.1 5.3 24.1 13.8L248.5 401c5.7 9.8 9.3 21.1 6.7 32.1C244.3 478 192 512 129.2 512zM320 112a32 32 0 1 0 0-64 32 32 0 1 0 0 64z" />
  </svg>
);
export default SvgScaleUnbalanced;
